module.exports = __webpack_public_path__ + "media/images/Cata-15-c9a273f04f4e15555f477d700f0e5ba7.jpg";